import axios from "axios";
import {
  IAccount,
  IClaimantInfo,
  IExpenseProcessed,
  IExpenseRequest,
  UserInfo,
} from "../interfaces";
import { createAsyncThunk } from "@reduxjs/toolkit";



export const MAIN_URL = process.env.REACT_APP_ENV === "development" ? "http://localhost:3503" : (process.env.REACT_APP_ENV === "production" ? "https://eap.claimscon.org"  : "https://eaptest.claimscon.org")


axios.defaults.withCredentials = true;
export const login = createAsyncThunk<any, any>(
  "userSlice/login",
  async ({regNumber, password}, { rejectWithValue }) => {
    try {

      const { data } = await axios.post(`${MAIN_URL}/user/login`, {
        regNumber: regNumber,
        password: password,
      });

      return data as any;
    } catch (err: any) {
      
      return rejectWithValue(err.response.data);
    }
  }
);


export const startRegistration = createAsyncThunk<any, any>(
  "userSlice/startRegistration",
  async (userInfo: UserInfo, { rejectWithValue }) => {
    try {

      const { data } = await axios.post(`${MAIN_URL}/user/start_registration`,userInfo);

      return data as any;
    } catch (err: any) {
      
      return rejectWithValue(err.response.data);
    }
  }
);


export const resetPassword = createAsyncThunk<any, any>(
  "userSlice/resetPassword",
  async (
    {password, token},
 { rejectWithValue }) => {
    try {

      const { data } = await axios.post(`${MAIN_URL}/user/password_reset/`,{password, token});

      return data as any;
    } catch (err: any) {
      
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendRegNum = createAsyncThunk<any, any>(
  "userSlice/sendRegNum",
  async (regNum: number, { rejectWithValue }) => {
    try {

      const { data } = await axios.get(`${MAIN_URL}/user/send_regNum/${regNum}`);

      return data as { result: boolean; msg: string };
    } catch (err: any) {
      
      return rejectWithValue(err.response.data);
    }
  }
);


export async function uploadFiles(args: { formData: FormData; fund: string; regNum: string, expense: IExpenseRequest }) {
  const {formData, expense, regNum} = args
console.log(expense)
  axios.defaults.withCredentials = false;
  const response = await axios({
    method: "post",
    url:  process.env.NODE_ENV === "production" ? `https://dnd.claimscon.org/api/files/${regNum}/eap_expenses` : `https://dndtest.claimscon.org/api/files/${regNum}/eap_expenses`,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });




console.log(response)
  const data: { result: boolean; msg: string } = response.data;
  if (data.result === true && data.msg === "success"){
    console.log(expense)
    axios.defaults.withCredentials = true;
    const response = await axios({
  method: "post",
url: `${MAIN_URL}/form/submit_expense/${regNum}`,
data: expense

})
console.log(response)
  }
  return data

}

export const logoutAPI = createAsyncThunk<any, any>(
  "userSlice/logoutAPI",
  async (expired: boolean,
{ rejectWithValue }) => {
  localStorage.clear();

    try {

      const { data } = await axios.post(`${MAIN_URL}/user/logout`, {expired});

      return data as any;
    } catch (err: any) {
      
      return rejectWithValue(err.response.data);
    }
  }
);

export const ping = createAsyncThunk<any, any>(
  "userSlice/ping",
  async(a: String, {rejectWithValue}) => {
    try{
      const response = await axios.get(`${MAIN_URL}/user/ping`);
  console.log(response)
  const data: {
    result: boolean;
    account: IAccount;
    claimantInfo: IClaimantInfo;
    msg: string;

    expenses: IExpenseProcessed[];

  } = response.data;

    const answer = { data};
return answer
    }catch(err: any){
      return rejectWithValue(err.response.data)
    }
  }
)

